<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-welcome-coupon"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="icon-close" @click="clickCancel()">
                        <img src="../../../../assets/icon/otp_icon_close@2x.png">
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="title">
                        {{lbl.register.welcomePoint.title}}
                    </div>
                    <div class="logo">
                        <img class="img-fluid" src="../../../../assets/logo/navbar_logo_naos@3x.png">
                    </div>
                    <div class="text-welcome-success" 
                        v-html="message">
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-confirm" @click="clickOk()" v-if="!isDisable">
                        <div class="btn-txt">
                            {{btnOk}}
                        </div>
                    </div>
                    <div class="btn-confirm disabled" v-else>
                        <div class="btn-txt">
                            {{btnOk}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {WelcomeCouponModalController} controller (required) /components/Modal/Controller/WelcomeCouponModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "WelcomeCouponModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            message: '',
            btnOk: '',
            tag: '',
            point: 0,
            isDisable: false,  
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.point = config.point;
            this.isDisable = config.isDisable;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import '@/style/input/BaseButton.scss';
    @import "@/style/modal.scss";
    @import "../style/WelcomeCouponModal.scss";
.modal-welcome-coupon{
    .modal-base{
        .modal-base-footer{
            .btn-confirm{
                @include btn-wrapper();
                width: 100%;
                margin: 0 auto;
            }
        }
    }
}
</style>
